import { ComponentType, ReactNode } from 'react';
import { Box, Stack, SvgIconProps, Typography } from '@mui/material';

interface PageHeaderProps {
  icon: ComponentType<SvgIconProps>;
  title: string;
  subtitle?: string;
  color?: string;
  actions?: ReactNode;
}

/** Shared title bar for list/CRUD pages: icon avatar + title + subtitle, actions on the right. */
export const PageHeader = ({ icon: Icon, title, subtitle, color = '#5B2DA3', actions }: PageHeaderProps) => (
  <Stack direction="row" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={2} sx={{ mb: 3 }}>
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: 2.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: `${color}1a`,
          color,
          flexShrink: 0,
        }}
      >
        <Icon />
      </Box>
      <Box>
        <Typography variant="h5">{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
    </Stack>
    {actions && (
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {actions}
      </Stack>
    )}
  </Stack>
);
